/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-11 15:48:01
 * @FilePath: /vise/packages/app-share/src/constants/index.ts
 */

export const DEFAULT_ERR_MSG = '请稍后再试';

// 事件总线监听的最大数量
export const MAX_LISTENERS_CNT = 40;
